import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'

export const breadcrumbStyle = {
    pt: {base: '23px'},
    pb: {base: '31px'},
    px: {base: '28px', md: '20px', xl: '28px'},
    fontSize: '14px',
    maxW: {base: '300px', md: '100%'},
    fontWeight: 600,
    letterSpacing: '4px',
    textTransform: 'uppercase',
    lineHeight: '20px',
    color: colors.cav_light_black,
    textDecoration: 'none',
    gap: '6px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
}

export const textStyle = {
    color: colors.black,
    fontFamily: fonts.primary
}

export const linkStyle = {
    _hover: 'none'
}

export const separatorStyle = {
    color: colors.cav_red_separator,
    fontWeight: 600,
    mx: '6px'
}
